import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import React from 'react'

import IconText from '@/app/component/layout/icon-text'
import CustomDialog from '@/app/component/wrapper/custom-dialog'
import TopupForm, { getTopupType, type TopupType } from '@/app/module/campaigns/component/topup'
import { displayMap, Q_ACTIONS } from '@/app/module/campaigns/definitions'
import type { LocalTopupAction } from '@/app/module/campaigns/types'
import type { PersonalizationType } from '@/app/types'

type TopupPayload = LocalTopupAction['topup']

type Props = {
  isNewAction?: boolean
  personalizationList?: PersonalizationType
  value?: Partial<LocalTopupAction>

  onClose: () => void
  onSave: (value: Partial<LocalTopupAction>) => void
}

const unwrapValue = (value?: Partial<LocalTopupAction>) => ({
  maxAmount: value?.topup?.maxAmount ?? '',
  maxAmountTemplated: value?.topup?.maxAmountTemplated ?? '',
  desiredAmountTemplated: value?.topup?.desiredAmountTemplated ?? '',
})

const Topup: React.FC<Props> = (props) => {
  const { onClose, onSave, value = {}, personalizationList = {} } = props
  const { maxAmount, maxAmountTemplated, desiredAmountTemplated } = unwrapValue(value)
  const [disabled, setDisabled] = React.useState<boolean>(false)
  const [topupType, setTopupType] = React.useState<TopupType>(
    getTopupType(desiredAmountTemplated, maxAmount, maxAmountTemplated),
  )
  const [topup, setTopup] = React.useState<TopupPayload>(unwrapValue(value))

  return (
    <CustomDialog open={true} onClose={onClose}>
      <DialogTitle style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <IconText>
            <Icon>{displayMap.topup.icon}</Icon>
            <Typography variant="h6">{Q_ACTIONS.topup.label}</Typography>
          </IconText>
          <IconButton onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            width: '80vw',
            minWidth: '300px',
            maxWidth: '100%',
          }}
        >
          <TopupForm
            desiredAmountTemplated={desiredAmountTemplated}
            maxAmount={maxAmount}
            maxAmountTemplated={maxAmountTemplated}
            personalizationList={personalizationList}
            topupType={topupType}
            setDisabled={setDisabled}
            setTopup={setTopup}
            setTopupType={setTopupType}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          disabled={disabled}
          onClick={() =>
            onSave({
              topup,
            } as Partial<LocalTopupAction>)
          }
        >
          Save
        </Button>
      </DialogActions>
    </CustomDialog>
  )
}

export default Topup
